/**
 * Type that desrcibe an assets relationship to content
 * @module services/assets/content-relationship-types
 */

export const ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_NO_TEXT = 'd6-hero-no-text'
export const ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_WITH_TEXT = 'd6-hero-with-text'
export const ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_NO_TEXT = 'd6-keyart-no-text'
export const ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_WITH_TEXT = 'd6-keyart-with-text'
export const ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_WITH_TEXT = 'keyart-4k-with-text'
export const ASSET_CONTENT_REFERENCE_TYPE_KEYART_4X3_WITH_TEXT = 'keyart-4x3-with-text'
export const ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_NO_TEXT = 'keyart-4k-no-text'
export const ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_WITH_TEXT = 'keyart-2k-with-text'
export const ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_NO_TEXT = 'keyart-2k-no-text'
export const ASSET_CONTENT_REFERENCE_TYPE_KEYART_2X3_WITH_TEXT = 'keyart-2x3-with-text'
export const ASSET_CONTENT_REFERENCE_TYPE_1X1_WITH_TEXT = '1x1-with-text'
export const ASSET_CONTENT_REFERENCE_TYPE_1X1_NO_TEXT = '1x1-no-text'
export const ASSET_CONTENT_REFERENCE_TYPE_PERSON_HEADSHOT_CIRCLE = 'd6-person-headshot-circle'
export const ASSET_CONTENT_REFERENCE_TYPE_HEADSHOT = 'headshot-image'
export const ASSET_CONTENT_REFERENCE_TYPE_TERM = 'term'
export const ASSET_CONTENT_REFERENCE_TYPE_GUIDE_MATERIAL = 'guide-material'
export const ASSET_CONTENT_REFERENCE_TYPE_VISUAL_INTEREST = 'visual-interest'
export const ASSET_CONTENT_REFERENCE_TYPE_TOPICS_ROW = 'topics-row-image'
export const ASSET_CONTENT_REFERENCE_TYPE_POSTER_3X4 = 'd6-poster-3x4'
/** 9:16 poster for vertical clips (Moments / short-form) */
export const ASSET_CONTENT_REFERENCE_TYPE_POSTER_9X16 = 'd6-poster-9x16'
export const ASSET_CONTENT_REFERENCE_TYPE_POSTER_IMAGE = 'd6-poster-image'
export const ASSET_CONTENT_REFERENCE_TYPE_PORTRAIT = 'd6-portrait'
export const ASSET_CONTENT_REFERENCE_TYPE_LOGO = 'd6-logo'
export const ASSET_CONTENT_REFERENCE_TYPE_WORKSHEET = 'worksheet'
export const ASSET_REFERENCE_TYPE_YI_COURSE_MODULE_DOWNLOAD = 'yi-course-module-download'
export const ASSET_REFERENCE_TYPE_YI_EMBEDDED_IMAGE = 'yi-embedded-image'

/**
 * Get an array of all content refernce types
 * @returns {String[]} A list of all content refernce types
 */
export function getAllContentReferenceTypes () {
  return [
    ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_NO_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_WITH_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_NO_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_KEYART_4X3_WITH_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_KEYART_2X3_WITH_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_WITH_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_NO_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_WITH_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_NO_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_1X1_WITH_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_1X1_NO_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_WITH_TEXT,
    ASSET_CONTENT_REFERENCE_TYPE_GUIDE_MATERIAL,
    ASSET_CONTENT_REFERENCE_TYPE_VISUAL_INTEREST,
    ASSET_CONTENT_REFERENCE_TYPE_TOPICS_ROW,
    ASSET_CONTENT_REFERENCE_TYPE_POSTER_3X4,
    ASSET_CONTENT_REFERENCE_TYPE_POSTER_9X16,
    ASSET_CONTENT_REFERENCE_TYPE_POSTER_IMAGE,
    ASSET_CONTENT_REFERENCE_TYPE_PERSON_HEADSHOT_CIRCLE,
    ASSET_CONTENT_REFERENCE_TYPE_PORTRAIT,
    ASSET_CONTENT_REFERENCE_TYPE_LOGO,
    ASSET_CONTENT_REFERENCE_TYPE_TERM,
    ASSET_CONTENT_REFERENCE_TYPE_HEADSHOT,
    ASSET_CONTENT_REFERENCE_TYPE_WORKSHEET,
  ]
}
